import BrokerSSOValuesProvider from './bsso/BrokerSSOValuesProvider';
import INGSSOValuesProvider from './isso/INGSSOValuesProvider';
import PrivateCustomerValuesProvider from './pc/PrivateCustomerValuesProvider';
import CSSOValuesProvider from './csso/CSSOValuesProvider';

export default function getClientValuesProvider(clientCode) {
    switch (clientCode) {
        case 'BSSO':
            return new BrokerSSOValuesProvider();
        case 'ISSO':
            return new INGSSOValuesProvider();
        case 'CSSO':
            return new CSSOValuesProvider();
        default:
            return new PrivateCustomerValuesProvider();
    }
}